var _path, _path2, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgService(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2C4.13401 2 1 5.13401 1 9C1 12.866 4.13401 16 8 16H9.32143L11.9065 18.7839C12.5056 19.4291 13.5858 19.0411 13.6375 18.1621L13.7781 15.7722C16.783 14.9854 19 12.2516 19 9C19 5.13401 15.866 2 12 2H8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32143 16L9.68783 15.6598L9.53946 15.5H9.32143V16ZM11.9065 18.7839L11.5401 19.1241L11.9065 18.7839ZM13.6375 18.1621L13.1384 18.1328L13.6375 18.1621ZM13.7781 15.7722L13.6515 15.2885L13.3003 15.3804L13.279 15.7428L13.7781 15.7722ZM1.5 9C1.5 5.41015 4.41015 2.5 8 2.5V1.5C3.85786 1.5 0.5 4.85786 0.5 9H1.5ZM8 15.5C4.41015 15.5 1.5 12.5899 1.5 9H0.5C0.5 13.1421 3.85786 16.5 8 16.5V15.5ZM9.32143 15.5H8V16.5H9.32143V15.5ZM8.95503 16.3402L11.5401 19.1241L12.2729 18.4436L9.68783 15.6598L8.95503 16.3402ZM11.5401 19.1241C12.4387 20.0919 14.0591 19.5099 14.1367 18.1915L13.1384 18.1328C13.1125 18.5723 12.5724 18.7662 12.2729 18.4436L11.5401 19.1241ZM14.1367 18.1915L14.2772 15.8015L13.279 15.7428L13.1384 18.1328L14.1367 18.1915ZM18.5 9C18.5 12.0186 16.4418 14.5578 13.6515 15.2885L13.9048 16.2559C17.1241 15.4129 19.5 12.4845 19.5 9H18.5ZM12 2.5C15.5899 2.5 18.5 5.41015 18.5 9H19.5C19.5 4.85786 16.1421 1.5 12 1.5V2.5ZM8 2.5H12V1.5H8V2.5Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.25,
    cy: 9.25,
    r: 1.25,
    fill: "#FF8D00"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.25,
    cy: 9.25,
    r: 1.25,
    fill: "#FF8D00"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.25,
    cy: 9.25,
    r: 1.25,
    fill: "#FF8D00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service.a7f5687be56e2d2a51cff03ba7050444.svg";
export { ForwardRef as ReactComponent };